import qs from 'qs';

import { ADVANCED_METRICS_V2 } from '../../../utils/advanced-metrics';
import { csvOnlyBaseDataPointsOptions } from '../../../components/AdvancedExportModal/configs/report';

export const staticColumns = [{
  text: 'Export Name',
  dataField: 'name',
  sortable: true,
  sortBy: 'name',
}, {
  text: 'Entities',
  dataField: 'entities',
}, {
  text: 'Date Range',
  dataField: 'date_range',
  className: 'th-date-range',
}, {
  text: 'Data Points',
  dataField: 'data_points',
  sortable: true,
  sortBy: 'data_points',
}, {
  text: 'Created',
  dataField: 'created_at',
  sortable: true,
  sortBy: 'created_at',
  className: 'th-created-at',
}, {
  text: 'Last Run',
  dataField: 'last_run',
  sortable: true,
  sortBy: 'updated_at',
  className: 'th-last-run',
}, {
  text: '',
  dataField: 'actions',
}];

export const METRICS = {
  downloads: 'Downloads',
  mau: 'Monthly Active Users',
  iap_revenue: 'IAP Revenue',
  sessions: 'Total Sessions',
  dau: 'Daily Active Users',
  total_time: 'Total Time Spent In App',
};

export const SELECTION_KIND = {
  none: 'none',
  all: 'all',
};

export const DATA_POINTS = {
  ...METRICS,
  ...ADVANCED_METRICS_V2,
  ...csvOnlyBaseDataPointsOptions.reduce((acc, { value, text }) => {
    acc[value] = text;
    return acc;
  }, {}),
};

// Location search params
const { export_generating_notify } = (() => {
  if (window.location.search.length > 0) {
    return qs.parse(window.location.search.slice(1));
  }

  return {};
})();

export const showProcessingNotify = !!export_generating_notify;
